import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg//evaluations.svg',
})
export class EvaluationsComponent {}
